import { faker } from '@faker-js/faker'
import { Factory, trait } from 'miragejs'
import { subDays, addDays } from 'date-fns'
import { SubscriptionType } from 'district-ui-client/domain/subscription-type'

export default Factory.extend({
  /**
   * Create a predetermined seed order, so they will always be the same, as per documentation
   * @see https://github.com/marak/Faker.js/#setting-a-randomness-seed
   * @param {number} i - running index
   * @returns {string}
   */
  name(i) {
    faker.seed(i)
    const name = `${faker.company.name()} Blake`
    return name
  },

  schoolCode() {
    return faker.word.sample()
  },

  afterCreate(school, server) {
    if (!school.contactDetail) server.create('contact-detail', { school })
  },

  withStudents: trait({
    afterCreate(school, server) {
      server.createList('student', 5, { school })
    },
  }),

  withTeachers: trait({
    afterCreate(school, server) {
      server.createList('teacher', 2, { school })
    },
  }),

  withoutSubscription: trait({
    afterCreate(_school, _server) {},
  }),

  withReadingSubscription: trait({
    afterCreate(school, server) {
      const startDate = subDays(new Date(), 1)
      const endDate = addDays(new Date(), 1)
      server.create('school-subscription', {
        school,
        subscriptionType: 'reading',
        startDate,
        endDate,
        softCapacity: '300',
      })
      server.create('school-subscription-utilisation', {
        school,
        subscriptionType: 'reading',
        startDate,
        endDate,
        studentCount: 100,
        licenceCount: 300,
      })
    },
  }),
  withMathsSubscription: trait({
    afterCreate(school, server) {
      const startDate = subDays(new Date(), 1)
      const endDate = addDays(new Date(), 1)
      server.create('school-subscription', {
        school,
        subscriptionType: 'maths',
        startDate,
        endDate,
        softCapacity: '300',
      })
      server.create('school-subscription-utilisation', {
        school,
        subscriptionType: 'maths',
        startDate,
        endDate,
        studentCount: 100,
        licenceCount: 300,
      })
    },
  }),
  withMathleticsSubscription: trait({
    afterCreate(school, server) {
      const startDate = subDays(new Date(), 1)
      const endDate = addDays(new Date(), 1)
      server.create('school-subscription', {
        school,
        subscriptionType: 'mathletics',
        startDate,
        endDate,
        softCapacity: '300',
      })
      server.create('school-subscription-utilisation', {
        school,
        subscriptionType: 'mathletics',
        startDate,
        endDate,
        studentCount: 100,
        licenceCount: 300,
      })
    },
  }),
  withPartnerContactDetails: trait({
    afterCreate(_school, server) {
      server.create('partner-contact-detail', { subscriptionType: SubscriptionType.Reading })
      server.create('partner-contact-detail', { subscriptionType: SubscriptionType.Maths })
      server.create('partner-contact-detail', { subscriptionType: SubscriptionType.Writing })
      server.create('partner-contact-detail', { subscriptionType: SubscriptionType.Mathletics })
    },
  }),
  classlink: trait({
    usesExternalRostering: true,
    externalRosteringSource: 'classlink',
  }),
})
